import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mav-sice-logo',
  templateUrl: './sice-logo.component.html',
  styleUrls: ['./sice-logo.component.scss']
})
export class SiceLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
